import React from "react";
import "./Partners.css";

export const Partners = () => {
  const partners = [
    {
      name: "Renoma Paris",
      logo: "/images/partners/renoma.png",
      url: "https://www.renoma-paris.com/boutique-renoma/",
      alt: "Logo Renoma Paris"
    },
    {
      name: "Maison XXL",
      logo: "/images/partners/maison-xxl.png", 
      url: "https://www.xxl.fr/fr/",
      alt: "Logo Maison XXL"
    },
    {
      name: "Olivia Goldman",
      logo: "/images/partners/logo-goldman.webp",
      url: "https://ogoldman.com/",
      alt: "Logo Olivia Goldman Communication"
    }
  ];

  return (
    <div id="partners" className="partners-section">
      <div className="container">
        <div className="partners-header">
          <h2 className="partners-title">Nos Partenaires</h2>
        </div>
        
        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div key={index} className="partner-card">
              <a 
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="partner-link"
              >
                <div className="partner-logo">
                  <img 
                    src={partner.logo}
                    alt={partner.alt}
                    loading="lazy"
                  />
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

